// extracted by mini-css-extract-plugin
export default {"Box":"FollowUpForm_Box__jHQoe"};